import { render, staticRenderFns } from "./deletePrinterRuleMachine.vue?vue&type=template&id=2d2d4830&scoped=true"
import script from "./deletePrinterRuleMachine.vue?vue&type=script&lang=js"
export * from "./deletePrinterRuleMachine.vue?vue&type=script&lang=js"
import style0 from "./deletePrinterRuleMachine.vue?vue&type=style&index=0&id=2d2d4830&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2d4830",
  null
  
)

export default component.exports